import React from "react";
import {
  UnorderedListOutlined,
  ApartmentOutlined,
  FileTextOutlined,
  RadiusSettingOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import {
  ConnectionPage,
  ItemPage,
  Login,
  OrderPage,
  ReportPage,
} from "../../pages";

export const routes = {
  login: "/",
  order: "/order",
  item: "/item",
  connection: "/connection",
  inventory: "/inventory",
  account: "/account",
  rol: "/rol",
  help: "/order",
  user: "/user",
  report: "/report",
};

export const AppPages = [
  { path: routes.login, protected: false, component: <Login /> },
  { path: routes.order, protected: true, component: <OrderPage /> },
  { path: routes.item, protected: true, component: <ItemPage /> },
  { path: routes.connection, protected: true, component: <ConnectionPage /> },
  { path: routes.report, protected: true, component: <ReportPage /> },
];

export const MenuItems: MenuProps["items"] = [
  {
    label: "Orders",
    key: routes.order,
    icon: <UnorderedListOutlined className="icon" />,
  },
  {
    label: "Item",
    key: routes.item,
    icon: <ApartmentOutlined className="icon" />,
  },
  {
    label: "Connection",
    key: routes.connection,
    icon: <RadiusSettingOutlined className="icon" />,
  },
  {
    label: "Reports",
    key: routes.report,
    icon: <FileTextOutlined className="icon" />,
  },
];
